angular.module('impactx.deliverynote').directive('ixDeliveryNoteItem', function () {
    return {
        restrict: 'E',
        controller: 'DeliveryNoteItemCtrl',
        controllerAs: 'deliveryNoteItemCtrl',
        templateUrl: 'modules/deliverynote/templates/deliverynoteitem.html',
        bindToController: {
            item: '=',
            trns: '=',
            selectedItems: "=",
            readOnly: "=",
            deleteFunc: "&",
            recreateFunc: "&",
            isDeletedList: "=",
            showArrivalDate: "="
        }
    }
});